import React, { useState } from 'react';
import { img_path } from '../../../environment';

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  loading?: boolean;
  style?: React.CSSProperties;
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const ImageWithoutBasePath = (props: Image) => {
  const fullSrc = props.src;

  return (
    <div className="image-container position-relative">
      {props?.loading && (
        <div 
          className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
          style={{background: '#f8f9fa'}}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <img
        className={props.className}
        src={fullSrc}
        height={props.height}
        alt={props.alt}
        width={props.width}
        id={props.id}
        style={{ visibility: props?.loading ? 'hidden' : 'visible', ...props.style }}
        onError={props.onError ?? undefined}
      />
    </div>
  );
};

export default ImageWithoutBasePath;
